var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowLoading)?_c('div',{staticClass:"loading-wrap"},[_c('img',{attrs:{"src":require("@img/third_login_loading.gif"),"alt":"加载中"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }